export default function PlaceHolder() {
  return (
    <span className="placeholder-glow">
      <span className="placeholder col-9" />
    </span>
  );
}
